import { render, staticRenderFns } from "./ServicePoints.vue?vue&type=template&id=5b394c68&scoped=true&"
import script from "./ServicePoints.vue?vue&type=script&lang=ts&"
export * from "./ServicePoints.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePoints.vue?vue&type=style&index=0&id=5b394c68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b394c68",
  null
  
)

export default component.exports